import * as React from 'react';
import * as ReactGA from 'react-ga';
import c from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './KudoCounter.css';
import { setRating } from '../../apis/dumpert';
import { formatNumber } from '../../lib/helpers';

export class KudoCounter extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      kudos: props.numOfKudos,
      rated: false,
    };
  }

  async changeKudoAmount(direction) {
    const { rated, kudos } = this.state;
    const { itemId } = this.props;
    const directionRename = direction === 'down' ? 'Min' : 'Plus';
    if (rated) {
      return;
    }
    ReactGA.event({
      category: 'Item Kudo',
      action: `Item${directionRename}Kudo`,
      label: `${itemId} ${directionRename}`,
    });
    try {
      const result = await setRating(itemId, direction);
      if (result.data.success) {
        this.setState({ kudos: (direction === 'down' ? kudos - 1 : kudos + 1), rated: direction });
      } else {
        this.setState({ rated: true });
      }
    } catch (e) {

      // no-op
    }
  }

  kudosColor(numOfKudos) {
    const str = numOfKudos.toString();
    return str.includes('-') ? styles.minus : styles.plus;
  }

  render() {
    const { rated, kudos } = this.state;
    return (
      <div className={styles.kudocounter}>
        <div
          className={c(styles.direction_container, styles.up, { [styles.voted]: rated === 'up' })}
          onClick={this.changeKudoAmount.bind(this, 'up')}
        >
          <FontAwesomeIcon icon={['fas', 'plus']} size="lg"/>
        </div>
        <div className={styles.number_of_kudos}>
          <span className={c({ [this.kudosColor(kudos)]: kudos !== 0 })}>
            {formatNumber(kudos)}
          </span>
          <span>kudos</span>
        </div>
        <div
          className={c(styles.direction_container, styles.down, { [styles.voted]: rated === 'down' })}
          onClick={this.changeKudoAmount.bind(this, 'down')}
        >
          <FontAwesomeIcon icon={['fas', 'minus']} size="lg"/>
        </div>
      </div>
    );
  }
}